import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { LoginFormComponent } from './login-form/login-form.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { SignUpComponent } from './sign-up/sign-up.component';
import { LoginComponent } from './login.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { QaModule } from '@daysmart/angular-qa-module';

@NgModule({
    declarations: [
        LoginComponent,
        LoginFormComponent,
        ResetPasswordComponent,
        SignUpComponent,
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatButtonModule,
        MatInputModule,
        MatCheckboxModule,
        MatCardModule,
        MatIconModule,
        MatProgressSpinnerModule,
        QaModule,
    ],
    exports: [LoginComponent, MatProgressSpinnerModule],
})
export class LoginModule {}
